import React, { useState, useEffect } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

const SearchInput = ({
    search,
    setSearch,
    setParams,
    limit,
    fullWidth = false,
    placeholder = '',
}) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(search);
    const debouncedSearch = useDebounce(inputValue, 500);

    useEffect(() => {
        setInputValue(search);
    }, [search]);

    useEffect(() => {
        if (debouncedSearch !== search && debouncedSearch === inputValue) {
            if (setParams) {
                setParams((prev) => ({ ...prev, page: 0 }));
            }
            setSearch(debouncedSearch);
        }
    }, [debouncedSearch]);

    const handleClear = () => {
        setInputValue('');
    };

    return (
        <TextField
            autoFocus
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <CloseIcon
                            size="small"
                            sx={{
                                visibility: inputValue ? 'visible' : 'hidden',
                                cursor: 'pointer',
                            }}
                            onClick={handleClear}
                        />
                    </InputAdornment>
                ),
            }}
            placeholder={placeholder === '' ? t('searchPlaceholder') : placeholder}
            value={inputValue || ''}
            size="small"
            onChange={(ev) => {
                setInputValue(ev.target.value);
            }}
            fullWidth={fullWidth}
        />
    );
};

export default SearchInput;
